import { Controller } from "@hotwired/stimulus"

// Manages control band override selection for both demo layouts.
// Each demo section is a separate target scope (demo1, demo2).
export default class extends Controller {
  static targets = ["band", "reasonInput", "modalBody"]

  connect() {
    // Track selected override per demo section
    this._selected = { demo1: null, demo2: null }
  }

  selectBand(event) {
    const btn = event.currentTarget
    const demo = btn.dataset.demo
    const bandNumber = btn.dataset.band

    // Deselect previous in this demo
    this.bandTargets
      .filter(b => b.dataset.demo === demo && b !== btn)
      .forEach(b => {
        b.classList.remove("active-override")
        const label = b.parentElement.querySelector(".override-label")
        if (label) label.style.display = "none"
      })

    // Toggle this button
    const isAlreadySelected = btn.classList.contains("active-override")
    if (isAlreadySelected) {
      btn.classList.remove("active-override")
      const label = btn.parentElement.querySelector(".override-label")
      if (label) label.style.display = "none"
      this._selected[demo] = null
    } else {
      btn.classList.add("active-override")
      const label = btn.parentElement.querySelector(".override-label")
      if (label) label.style.display = "block"
      this._selected[demo] = bandNumber
    }
  }

  submit(event) {
    const demo = event.currentTarget.dataset.demo
    const reasonInput = this.reasonInputTargets.find(el => el.dataset.demo === demo)
    const modalBody = this.modalBodyTargets.find(el => el.dataset.demo === demo)

    const selectedBand = this._selected[demo]
    const reason = reasonInput ? reasonInput.value.trim() : ""

    // Build warnings
    const warnings = []
    if (!selectedBand) warnings.push("No override band was selected.")
    if (!reason) warnings.push("Reason is required but was left blank.")

    // Band data for display
    const bandInfo = {
      "1": { label: "1: Low",            color: "#28a745" },
      "2": { label: "2: Moderate",        color: "#3b82f6" },
      "3": { label: "3: High",           color: "#DAA520" },
      "4": { label: "4: Very High",      color: "#e67e22" },
      "5": { label: "5: Extremely High", color: "#dc3545" }
    }

    const pillStyle = (color, muted) => {
      const bg = muted ? this._muteColor(color, 0.25) : color
      return `display:inline-block; padding:0.2em 0.75em; border-radius:999px; background-color:${bg}; color:#fff; font-weight:600; font-size:0.9em;`
    }

    let html = ""

    if (warnings.length > 0) {
      html += `<div class="alert alert-danger mb-3">`
      warnings.forEach(w => { html += `<div><i class="bi bi-exclamation-triangle-fill me-1"></i>${w}</div>` })
      html += `</div>`
    }

    const assignedPill = `<span style="${pillStyle(bandInfo["2"].color, true)}">${bandInfo["2"].label}</span>`
    const overridePill = selectedBand
      ? `<span style="${pillStyle(bandInfo[selectedBand].color, false)}">${bandInfo[selectedBand].label}</span>`
      : `<em>None selected</em>`

    html += `<table class="table table-sm mb-0">`
    html += `<tr><td class="text-muted" style="width: 40%;">Compound</td><td><strong>Tiger Balm</strong></td></tr>`
    html += `<tr><td class="text-muted">OEL Value</td><td>50 &mu;g/m<sup>3</sup></td></tr>`
    html += `<tr><td class="text-muted">Assigned Band</td><td>${assignedPill}</td></tr>`
    html += `<tr><td class="text-muted">Override Band</td><td>${overridePill}</td></tr>`
    html += `<tr><td class="text-muted">Reason</td><td>${reason ? this._escapeHtml(reason) : "<em>Not provided</em>"}</td></tr>`
    html += `</table>`

    modalBody.innerHTML = html

    // Show the modal
    const modalEl = modalBody.closest(".modal")
    const modal = bootstrap.Modal.getOrCreateInstance(modalEl)
    modal.show()
  }

  _escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }

  // Blend a hex color toward white by the given amount (0 = original, 1 = white)
  _muteColor(hex, amount) {
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)
    const blend = (c) => Math.round(c + (255 - c) * amount)
    return `rgb(${blend(r)}, ${blend(g)}, ${blend(b)})`
  }
}
